import { useEffect, useState } from 'react';

import { Box, Button, Fade, Stack, Typography } from '@mui/material';

import AppVersion from './AppVersion';
import SageLogoAnimation from './SageLogoAnimation';

interface SageLoaderProps {
    message?: string;
    hideSageLogo?: boolean;
    record?: boolean;
    showReloadLink?: boolean;
    showReloadAfter?: number;
    skipLogoIntro?: boolean;
}

function SageLoader(props: SageLoaderProps) {
    const {
        message = 'Loading...',
        hideSageLogo = false,
        showReloadLink = false,
        showReloadAfter = 5,
        skipLogoIntro = false,
    } = props;

    const [showReload, setShowReload] = useState<boolean>(false);

    useEffect(() => {
        if (!showReloadLink) return;

        const timeout = setTimeout(() => {
            setShowReload(true);
        }, showReloadAfter * 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [showReloadAfter, showReloadLink]);

    return (
        <Stack className="loader-wrapper">
            {!hideSageLogo && <SageLogoAnimation skipIntro={skipLogoIntro} />}
            <Box className="loader-label-wrapper">
                <Typography variant="h4" sx={{ color: 'black' }}>
                    {message}
                </Typography>
                <Fade in={showReload}>
                    <Box id="reload-page">
                        <Typography variant="h4">Stuck Loading? </Typography>
                        <Button
                            color="primary"
                            variant="contained"
                            size="small"
                            disableElevation
                            disabled={!showReload}
                            onClick={() => window.location.reload()}
                        >
                            Refresh the page
                        </Button>
                    </Box>
                </Fade>
                <div className="loader-app-version">
                    <AppVersion />
                </div>
            </Box>
        </Stack>
    );
}

export default SageLoader;
